import React from 'react';
import HelpHint from './HelpHint';

interface KpiCardProps {
  title: string;
  value: string | number;
  helper?: string;
  tone?: 'positive' | 'negative' | 'neutral';
  className?: string;
  helpText?: string;
  helpTitle?: string;
}

const KpiCard: React.FC<KpiCardProps> = ({ 
  title, 
  value, 
  helper, 
  tone = 'neutral',
  className = '',
  helpText,
  helpTitle
}) => {
  const getToneClasses = () => {
    switch (tone) {
      case 'positive':
        return 'text-emerald-500 dark:text-emerald-400';
      case 'negative':
        return 'text-rose-600 dark:text-rose-400';
      default:
        return 'text-foreground';
    }
  };

  return (
    <div className={`rounded-lg bg-card ring-1 ring-border p-3 md:p-4 h-[88px] flex flex-col justify-between ${className}`}>
      <div className="flex items-start justify-between">
        <div className="text-xs text-muted-foreground flex-1">{title}</div>
        {helpText && (
          <HelpHint 
            kind="kpi"
            shortText={helpText}
            longText={helpText}
            title={helpTitle || 'Vad visar denna indikator?'}
          />
        )}
      </div>
      <div className={`text-xl font-semibold ${getToneClasses()}`}>
        {value} {helper && <span className="text-sm text-muted-foreground">{helper}</span>}
      </div>
    </div>
  );
};

export default KpiCard;